/**
 * תצוגת צ'יפ "חבילה" בדשבורד — מקור אמת ראשוני: payload מ־/api/agents/me/entitlements
 * (package.code). צבע/מחלקת CSS נגזרים מ־feature flags, לא מ־plan.
 */

const NO_PACKAGE_LABEL_HE = "לא הוגדרה חבילה";

function _normalizePublicPackageCode(code) {
  const u = String(code || "").trim().toUpperCase();
  if (!u) return "";
  if (u === "STARTER" || u === "BASIC") return "BASIC";
  if (u === "PRO") return "PRO";
  if (u === "AGENCY") return "AGENCY";
  return "";
}

/**
 * תווית לצ'יפ — לפי package.code בלבד. STARTER legacy ממופה ל-BASIC.
 * @param {object|null|undefined} payload — גוף התשובה מ־entitlements
 * @param {string} status — agentEntitlementsStatus
 */
export function getCommercialPackageLabelHe(payload, status) {
  if (status === "loading") return "טוען…";
  const pkg = payload?.package;
  if (status === "ok" && pkg && typeof pkg === "object") {
    const code = _normalizePublicPackageCode(pkg.code);
    if (code === "AGENCY") return "סוכנות";
    if (code) return code;
  }
  return NO_PACKAGE_LABEL_HE;
}

/**
 * סיומת מחלקת CSS קיימת: dashboard-status-chip--plan-{suffix}
 * basic | advanced | pro — עדיפות לקריאת החבילה המוצגת (כמו תג הדשבורד).
 * @param {{ status: string, canUseDynamicPackages: boolean, canSearchHotels: boolean, canSearchPackages: boolean, displayedPackageCode?: string|null }} s
 */
export function getEntitlementsChipTierCssSuffix(s) {
  const {
    status,
    canUseDynamicPackages,
    canSearchHotels,
    canSearchPackages,
    displayedPackageCode,
  } = s || {};
  const disp = _normalizePublicPackageCode(displayedPackageCode);
  if (disp === "PRO") return "pro";
  if (status !== "ok") return "basic";
  if (canUseDynamicPackages) return "pro";
  if (canSearchHotels && canSearchPackages) return "advanced";
  return "basic";
}

/**
 * טקסט מלא לצ'יפ — מקדים "חבילה ·" רק כשיש קוד חבילה תקין מה־API.
 */
export function getCommercialChipLineHe(payload, status) {
  const label = getCommercialPackageLabelHe(payload, status);
  if (status === "loading") return `חבילה · ${label}`;
  const pkg = payload?.package;
  const code = _normalizePublicPackageCode(pkg?.code);
  const fromEntitlements =
    status === "ok" &&
    pkg &&
    typeof pkg === "object" &&
    code;
  if (fromEntitlements) return `חבילה · ${label}`;
  return label;
}
